import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

import { SortEvent } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Table } from 'primeng/table';
import { AuthService } from '../../_auth/auth.service';
import { AdminEditOperatorDetailsComponent } from '../admin-edit-operator-details/admin-edit-operator-details.component';
import { UserDetailsService } from '../../shared/services/user-details.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-admin-search-results',
  standalone: false,
  templateUrl: './admin-search-results.component.html',
  styleUrl: './admin-search-results.component.scss',
})
export class AdminSearchResultsComponent {
  @Input() searchResults: any;
  @Input() isAirmenAgentSearch: boolean;
  @Output() pageChange: EventEmitter<any> = new EventEmitter();
  @Output() sortOrderForSearch: EventEmitter<any> = new EventEmitter();
  @Input() columns: any;
  @Input() searchType: any;
  @Input() resetPagination: boolean

  @ViewChild('table') table: Table;
  users: any;
  public userData: any;
  first: number = 0;
  firstRow: number = 0;
  sortOrder: string;
  isFtnAgentSearch: boolean;
  isAdminUser: boolean;
  selectedAgent: any;
  selectedUser: any;

  constructor(
    private authService: AuthService,
    private dialogService: DialogService,
    public userDialogRef: DynamicDialogRef,
    private userDetailService: UserDetailsService,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.userData = this.authService.getUserData();
    this.users = this.searchResults?.items;
    this.isFtnAgentSearch = this.isAirmenAgentSearch?.valueOf();
    this.isAdminUser = this.authService.isTechSupportUser();
    if(this.resetPagination){
      this.firstRow = 0;
    }
  }

  ngOnChanges(changes: any) {
    this.first = this.firstRow;
    if (changes?.isAirmenSearch || changes?.resetPagination?.currentValue) {
      if (this.table) {
        this.table.reset();
        this.first = 0;
        this.firstRow = 0;
      }
      this.isFtnAgentSearch = changes?.isAirmenSearch?.currentValue?.valueOf();
      this.sortOrder = '';
    }
    this.users = changes?.searchResults?.currentValue?.items;
    if (this.searchType === 'externalUser') {
      this.users.forEach((item: any) => {
        item['userName'] = item.firstName + ' ' + item?.middleName + ' ' + item.lastName
      });
    }
    if (this.isAirmenAgentSearch) {
      this.users.forEach((item: any) => {
        item['operatorFirstName'] = item.operatorFirstName + ' ' + item.operatorLastName
      });
    }
  }

  onSort(event: SortEvent) {
    if (event.order === 1) {
      this.sortOrderForSearch.emit({ order: 'Ascending', field: event.field });
      this.sortOrder = 'Ascending';
    } else if (event.order === -1) {
      this.sortOrderForSearch.emit({ order: 'Descending', field: event.field });
      this.sortOrder = 'Descending';
    }
  }

  onPageChange(event: any) {
    this.firstRow = event.first;
    this.pageChange.emit(event);
  }

  openModal(header?: string, dialogData?: any) {
    const dialogRef = this.dialogService.open(
      AdminEditOperatorDetailsComponent,
      {
        header: header,
        width: '45%',
        closable: true,
        style: { 'border-radius': '0px' },
        contentStyle: { padding: '25px 25px 25px 25px' },
        height: '45%',
        data: {
          dialogData: dialogData,
          isFtnAgentSearch: this.isAirmenAgentSearch
        }
      }
    );
    if (dialogRef) {
      this.userDialogRef = dialogRef;
      this.userDialogRef.onClose.subscribe((formData) => {
      const internalUserForm = formData.formData;
      if (
        internalUserForm &&
        internalUserForm.status !== 'INVALID' &&
        !formData.isCancel
      ) {
        if (this.isAirmenAgentSearch) {
          const data = {
            firstName: internalUserForm.controls['operatorFirstName'].value,
            lastName: internalUserForm.controls['operatorLastName'].value,
            email: internalUserForm.controls['operatorEmail'].value,
            ftn: internalUserForm.controls['operatorFTN'].value,
            dob: internalUserForm.controls['operatorDob'].value,
            id: dialogData.operatorId
          };
          this.userDetailService
            .UpdateAirmenDetails(data)
            .subscribe((results) => {
              if (results.message === 'Success') {
                this.messageService.add({
                  severity: 'success',
                  summary: 'Success',
                  detail:
                    'Airman details were updated successfully',
                });
              }
              if (
                results.message ===
                'Airman details not found'
              ) {
                this.messageService.add({
                  severity: 'warn',
                  summary: 'Warning',
                  detail: results.message,
                });
              }
              this.refreshAirmenData({ skip: 0, take: 100, orderBy: [{ "sortDirection": "Descending", "propertyName": "operatorFtn" }] });
              formData.event?.preventDefault();
            });
        } else {
          const data = {
            arOwnerId: dialogData.arOwnerId,
            arOwnerName: internalUserForm.controls['arOwnerName'].value,
            nNumber: internalUserForm.controls['nNumber'].value,
            serialNo: internalUserForm.controls['serialNo'].value,
          };
          this.userDetailService
            .UpdateArOwner(data)
            .subscribe((results) => {
              if (results.message === 'Success') {
                this.messageService.add({
                  severity: 'success',
                  summary: 'Success',
                  detail:
                    'AR Owner details were updated successfully',
                });
              }
              if (
                results.message ===
                'AR Owner details not found'
              ) {
                this.messageService.add({
                  severity: 'warn',
                  summary: 'Warning',
                  detail: results.message,
                });
              }
              this.refreshArOwnerData({ skip: 0, take: 100, orderBy: [{ "sortDirection": "Descending", "propertyName": "arOwnerName" }] });
              formData.event?.preventDefault();
            });
          }
        }
      });
    }
  }

  editOperator(userData?: any) {
    let header = 'Edit Airman / Operator'
    if (!this.isAirmenAgentSearch) {
      header = 'Edit Aircraft Registered Owner'
    }
    this.openModal(header, userData);
  }

  deleteUser(userData?: any) {
    const dialogRef = this.dialogService.open(
      AdminEditOperatorDetailsComponent,
      {
        header: 'Delete User',
        width: '30%',
        closable: true,
        style: { 'border-radius': '0px' },
        contentStyle: { padding: '25px 25px 25px 25px' },
        height: '25%',
        data: {
          dialogData: '',
          isFtnAgentSearch: this.isAirmenAgentSearch,
          isDeleteUser: true
        }
      }
    );
    if (dialogRef) {
      this.userDialogRef = dialogRef;
      this.userDialogRef.onClose.subscribe((data) => {
      if (!data.isCancel) {
        console.log(userData);
        const data = {
          externalUserId: userData.externalUserId,
          externalUserEmail: userData.email,
          deletedBy: this.userData.sub
        }
        this.userDetailService
          .DeleteExternalUser(data)
          .subscribe((results) => {
            if (results.message === 'Success') {
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail:
                  'User has been deleted successfully',
              });
            }
            else {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: results.message,
              });
            }
            this.refreshExternalUsers({ skip: 0, take: 100, orderBy: [{ "sortDirection": "Descending", "propertyName": "firstName" }] });
            });
          }
        });
      }
    }

  refreshAirmenData(data: any) {
    this.userDetailService.SearchAirmenDetails(data).subscribe((results) => {
      this.users = results.items;
      this.users.forEach((item: any) => {
        item['operatorFirstName'] = item.operatorFirstName + ' ' + item.operatorLastName
      });
      if (this.table) {
        this.table.reset();
        this.first = 0;
        this.firstRow = 0;
      }
    });
  }
  refreshArOwnerData(data: any) {
    this.userDetailService.SearchArOwnerDetails(data).subscribe((results) => {
      this.users = results.items;
      if (this.table) {
        this.table.reset();
        this.first = 0;
        this.firstRow = 0;
      }
    });
  }
  refreshExternalUsers(data: any) {
    this.userDetailService.getExternalUsers(data).subscribe((results) => {
      this.users = results.items;
      this.users.forEach((item: any) => {
        item['userName'] = item.firstName + ' ' + item?.middleName + ' ' + item.lastName
      });
    });
  }

  activateUserEmail(userData? : any)
  {
      const data = {
        externalUserId: userData.externalUserId,
        externalUserEmail: userData.email,
        updatedBy: this.userData.sub
      }
      this.userDetailService
          .ActivateExternalUserEmail(data)
          .subscribe((results) => {
            if (results.message === 'Success') {
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail:
                  'User has been activated successfully',
              });
            }
            else {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: results.message,
              });
            }
            this.refreshExternalUsers({ skip: 0, take: 100, orderBy: [{ "sortDirection": "Descending", "propertyName": "firstName" }] });
          });
  }
}
